/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Dialog_Credentials_Quota_NoteInputs */



/**
* | output |
* | --- |
* | "Credentials are managed by oneAI, so no setup is required." |
*
* @param {Integrations_Dialog_Credentials_Quota_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_dialog_credentials_quota_note = /** @type {((inputs?: Integrations_Dialog_Credentials_Quota_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Dialog_Credentials_Quota_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugangsdaten werden von oneAI verwaltet, eine Einrichtung ist nicht erforderlich.")
	return /** @type {LocalizedString} */ ("Credentials are managed by oneAI, so no setup is required.")
});